<div class="app-container">
  <!-- Header avec Material Toolbar -->
  <mat-toolbar class="app-header">
    <div class="header-left d-flex align-items-center">
      <button (click)="drawer.toggle()" class="menu-toggle" mat-icon-button>
        <mat-icon>menu</mat-icon>
      </button>

      <!-- Breadcrumb sur desktop -->
      <div class="breadcrumb-wrapper d-none d-lg-flex align-items-center ms-3">
        <mat-icon class="breadcrumb-icon">home</mat-icon>
        <span class="breadcrumb-separator">/</span>
        <span class="breadcrumb-current">{{ getCurrentPageTitle() }}</span>
      </div>
    </div>

    <!-- Search Bar -->
    <div class="app-search-box d-none d-sm-block flex-grow-1 mx-3">
      <form (submit)="performSearch($event)" class="app-search-form">
        <div class="search-wrapper">
          <i class="bi bi-search search-icon-left"></i>
          <input
            aria-label="Rechercher"
            class="form-control search-input"
            placeholder="Rechercher des produits, commandes, clients..."
            type="text">
          <button class="btn search-btn" type="submit">
            Rechercher
          </button>
        </div>
      </form>
    </div>

    <!-- Mobile Search Trigger -->
    <button (click)="toggleMobileSearch($event)" class="d-sm-none search-trigger-mobile" mat-icon-button>
      <mat-icon>search</mat-icon>
    </button>

    <!-- Utilities -->
    <div class="app-utilities d-flex align-items-center gap-2">
      <!-- Quick Actions -->
      <div class="quick-actions d-none d-xl-flex align-items-center gap-1 me-2">
        <button mat-icon-button
                matTooltip="Nouveau produit"
                matTooltipPosition="below"
                routerLink="/administration/management/catalogue/products/create">
          <mat-icon>add_box</mat-icon>
        </button>
        <button mat-icon-button
                matTooltip="Voir les commandes"
                matTooltipPosition="below"
                routerLink="/administration/management/commerce/orders">
          <mat-icon>receipt_long</mat-icon>
        </button>
      </div>

      <!-- Notifications -->
      <button class="notification-btn" mat-icon-button matTooltip="Notifications">
        <mat-icon [matBadge]="notificationCount()" matBadgeColor="warn" matBadgeSize="small">notifications</mat-icon>
      </button>

      <!-- User Dropdown -->
      @if (user(); as user) {
        <div class="app-user-dropdown" ngbDropdown>
          <button
            class="user-profile-toggle btn d-flex align-items-center"
            ngbDropdownToggle>
            <div class="user-avatar-wrapper me-2">
              <img [src]="'' | avatar" alt="profil utilisateur" class="user-avatar">
              <span class="user-status-indicator"></span>
            </div>
            <div class="d-none d-md-flex flex-column align-items-start me-2">
              <span class="user-name">{{ user?.fullName }}</span>
              <span class="user-role">Administrateur</span>
            </div>
            <mat-icon class="dropdown-chevron d-none d-md-block">expand_more</mat-icon>
          </button>

          <ul class="dropdown-menu dropdown-menu-end user-dropdown-menu" ngbDropdownMenu>
            <li class="dropdown-header">
              <div class="d-flex align-items-center">
                <img [src]="'' | avatar" alt="profil" class="rounded-circle me-2" style="width: 40px; height: 40px;">
                <div>
                  <div class="fw-bold">{{ user?.fullName }}</div>
                  <small class="text-muted">{{ user.username }}</small>
                </div>
              </div>
            </li>
            <li>
              <hr class="dropdown-divider">
            </li>
            <li>
              <a class="dropdown-item" routerLink="/account/admin-dashboard">
                <mat-icon class="me-2" style="font-size: 18px; width: 18px; height: 18px;">person</mat-icon>
                Mon compte
              </a>
            </li>
            <li>
              <a class="dropdown-item" routerLink="/administration/management/settings">
                <mat-icon class="me-2" style="font-size: 18px; width: 18px; height: 18px;">settings</mat-icon>
                Paramètres
              </a>
            </li>
            <li>
              <hr class="dropdown-divider">
            </li>
            <li>
              <a (click)="logout()" class="dropdown-item text-danger cursor-pointer">
                <mat-icon class="me-2" style="font-size: 18px; width: 18px; height: 18px;">logout</mat-icon>
                Déconnexion
              </a>
            </li>
          </ul>
        </div>
      }

    </div>
  </mat-toolbar>

  <!-- Mobile Search Box -->
  <div [ngClass]="{'show': showMobileSearch}" class="app-search-box mobile-search">
    <form (submit)="performSearch($event)" class="app-search-form">
      <div class="search-wrapper">
        <i class="bi bi-search search-icon-left"></i>
        <input
          aria-label="Rechercher"
          class="form-control search-input"
          placeholder="Rechercher..."
          type="text">
        <button class="btn search-btn" type="submit">
          <mat-icon>search</mat-icon>
        </button>
      </div>
    </form>
  </div>
  <!-- Sidenav Container -->
  <mat-sidenav-container [hasBackdrop]="!isLargeScreen" class="sidenav-container">
    <!-- Sidenav (panneau latéral) -->
    <mat-sidenav
      #drawer
      [fixedBottomGap]="0"
      [fixedInViewport]="true"
      [fixedTopGap]="64"
      [mode]="isLargeScreen ? 'side' : 'over'"
      [opened]="isLargeScreen"
      class="app-sidenav">
      <ms-admin-side-panel (closeSidenav)="drawer.close()" [hasShowSidePanel]="drawer.opened"/>
    </mat-sidenav>

    <!-- Contenu principal -->
    <mat-sidenav-content class="sidenav-content">
      <div class="app-content">
        <router-outlet/>
      </div>

      <!-- Footer -->
      <footer class="app-footer">
        <mat-divider></mat-divider>
        <div class="footer-content">
          <div class="footer-left">
            <small class="copyright">
              &copy; {{ currentYear }} Muslim Shoco. Tous droits réservés.
            </small>
          </div>
          <div class="footer-right">
            <small class="copyright">Construit avec
              <span class="sr-only">amour</span>
              <i aria-hidden="true" class="bi bi-heart-fill heart-icon"></i>
              par <a class="app-link" [href]="contactInfo.developer.url" target="_blank">{{ contactInfo.developer.name }}</a>
            </small>
          </div>
        </div>
      </footer>

      <!-- Back to top button avec Material FAB -->
      <button
        (click)="scrollToTop()"
        [ngClass]="{'show': showBackToTop}"
        aria-label="Retour en haut"
        class="back-to-top"
        color="primary"
        mat-fab>
        <mat-icon>arrow_upward</mat-icon>
      </button>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
